import { Typography } from "@mui/material";
import { Theme } from "@mui/material";
import useCustomStyles from "@/core/hooks/useCustomStyles/useCustomStyles";

const styles = (theme: Theme) => ({
  error: {
    color: theme.palette.error.main,
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(1),
    fontSize: theme.spacing(1.5),
  },
});

const ErrorMessage = ({ text }: { text: string }) => {
  const classes: any = useCustomStyles(styles);
  return <Typography sx={classes?.error}>{text}</Typography>;
};

export default ErrorMessage;
